import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  adminInstance as axios,
} from '~/utils';

import { PseudoStates, PageTitle } from '@cordata/buffet';
import OutboundEmailForm from '~/components/OutboundEmail/Form';

const OutboundEmailDetails = () => {
  const params = useParams();
  const history = useHistory();
  const [bouncedEmail, setBouncedEmail] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    axios
      .get(`/outbound_email/${params.email_id}`)
      .then(response => {
        const emailData = response.data.data;
        setBouncedEmail(emailData);
      })
      .catch(e => setError(e))
      .then(() => setIsLoading(false));
  }, [params.email_id]);

  const handleEmailUpdate = (updatedEmail) => {
    setBouncedEmail(updatedEmail);
  };

  if (isLoading || error) {
    return (
      <PseudoStates
        isLoading={isLoading}
        error={error}
      />
    );
  }

  return (
    <>
      <PageTitle
        action={
          <Button
            color="secondary"
            size="sm"
            onClick={() => history.push('/admin/outbound-emails')}
          >
            <FontAwesomeIcon icon="arrow-left" className="mr-2" />
            Back to List
          </Button>
        }
      >
        Outbound Email Details
      </PageTitle>

      <OutboundEmailForm email={bouncedEmail} onUpdate={handleEmailUpdate} />
    </>
  );
};

OutboundEmailDetails.propTypes = {};

export default OutboundEmailDetails;
